// core/services/translationService.js

// --- Cookie helpers to keep Google Translate in sync with app state ---
const setCookie = (name, value) => {
  try {
    document.cookie = `${name}=${value}; path=/`;
    // Best-effort domain cookie (may fail on localhost, which is fine)
    const hostname = window.location.hostname;
    if (hostname && hostname.includes('.')) {
      document.cookie = `${name}=${value}; domain=.${hostname}; path=/`;
    }
  } catch (_) {}
};

const getStoredAppLanguage = () => {
  try {
    return localStorage.getItem('appLanguage') || 'ka';
  } catch (_) {
    return 'ka';
  }
};

const syncGoogTransCookie = (lang) => {
  // Google uses this cookie to auto-translate on load. Keep it aligned.
  // For base language use "/ka/ka" which reliably disables translation.
  const cookieValue = lang === 'ka' ? '/ka/ka' : `/ka/${lang}`;
  setCookie('googtrans', cookieValue);
};

// Expose a priming helper to set cookie as early as possible
export const primeGoogleTranslateCookie = () => {
  syncGoogTransCookie(getStoredAppLanguage());
};

let elementInitialized = false;

export const loadGoogleTranslate = () => {
  // Ensure cookie matches desired language BEFORE script loads
  syncGoogTransCookie(getStoredAppLanguage());

  // Load Google Translate script once
  if (!document.getElementById('google-translate-script')) {
    const script = document.createElement('script');
    script.id = 'google-translate-script';
    script.src =
      '//translate.google.com/translate_a/element.js?cb=initGoogleTranslate';
    script.defer = true;
    script.async = true;
    document.body.appendChild(script);
  } else {
    // If already present, re-init in case Google object exists
    if (window.google && window.google.translate) initGoogleTranslate();
  }
};

export const initGoogleTranslate = () => {
  if (!window.google || !window.google.translate) return;

  // Initialize Google translator
  if (!elementInitialized) {
    new window.google.translate.TranslateElement(
      {
        pageLanguage: 'ka', // Base language is Georgian
        includedLanguages: 'en,ka',
        autoDisplay: false,
      },
      'google_translate_element'
    );
    elementInitialized = true;
  }

  // --- Wait until translator is really ready ---
  const waitUntilReady = setInterval(() => {
    const selectEl = document.querySelector('.goog-te-combo');
    const iframe = document.querySelector('.goog-te-menu-frame');

    // Proceed only when both exist (select and translation iframe)
    if (selectEl && iframe) {
      clearInterval(waitUntilReady);
      // Apply the language stored by the app, preventing EN flash
      const lang = getStoredAppLanguage();
      syncGoogTransCookie(lang);
      forceLanguage(lang);
    }
  }, 300);
};

// Required global callback for Google script
window.initGoogleTranslate = initGoogleTranslate;

// --- Helper to force language change directly ---
export const forceLanguage = (lang) => {
  const selectEl = document.querySelector('.goog-te-combo');
  if (!selectEl) return false;

  selectEl.value = lang;
  const event = new Event('change', { bubbles: true });
  selectEl.dispatchEvent(event);
  return true;
};

// --- Public function to change language with retry ---
export const changeGoogleLanguage = (lang) => {
  syncGoogTransCookie(lang);
  let tries = 0;
  const maxTries = 40;
  const interval = setInterval(() => {
    const success = forceLanguage(lang);
    if (success || tries >= maxTries) clearInterval(interval);
    tries++;
  }, 250);
};
